import type {SystemStyleObject} from '@chakra-ui/styled-system';

type PathKeys<T> = T extends object
  ? {
      [K in keyof T]-?: K extends string | number
        ? `${K}` | (PathKeys<T[K]> extends infer R ? (R extends never ? never : `${K}.${R & string}`) : never)
        : never;
    }[keyof T]
  : never;

export const getCoreValueAsThemeToken = <T, P extends PathKeys<T>>(_obj: T, path: P) => {
  return path.split(`.`).slice(1).join(`.`);
};

export type MultipartStyles<Parts extends string> = Record<Parts, SystemStyleObject>;
